var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1597880666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.96393 18.2672H2.49096C2.03262 18.2672 1.66066 17.8952 1.66066 17.4369V2.491C1.66066 2.03266 2.03266 1.66069 2.49096 1.66069H9.96393C10.4231 1.66069 10.7942 1.28955 10.7942 0.830386C10.7942 0.371221 10.4231 0 9.96393 0H2.49096C1.11761 0 0 1.11765 0 2.491V17.4369C0 18.8102 1.11761 19.9278 2.49096 19.9278H9.96393C10.4231 19.9278 10.7942 19.5567 10.7942 19.0975C10.7942 18.6383 10.4231 18.2672 9.96393 18.2672Z",
    fill: "#E36C6C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.7477 9.37335L14.6994 4.39139C14.3739 4.06922 13.8475 4.07339 13.5253 4.39971C13.2031 4.72602 13.2064 5.25161 13.5336 5.57378L17.1414 9.1342H7.47386C7.0147 9.1342 6.64355 9.50535 6.64355 9.96451C6.64355 10.4237 7.0147 10.7949 7.47386 10.7949H17.1414L13.5336 14.3553C13.2065 14.6775 13.204 15.203 13.5253 15.5294C13.688 15.6938 13.9022 15.7768 14.1165 15.7768C14.3274 15.7768 14.5383 15.6971 14.6994 15.5376L19.7477 10.5557C19.9055 10.3996 19.9952 10.187 19.9952 9.96447C19.9952 9.74204 19.9063 9.5303 19.7477 9.37335Z",
    fill: "#E36C6C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLogout);
export default __webpack_public_path__ + "static/media/emailLogout.8fc28b34dd937ea8edefe70e251b8737.svg";
export { ForwardRef as ReactComponent };